import React, {Fragment} from "react";
import {connect} from "react-redux";
import {
    deleteContentRule,
    loadContentRules, updateContentRule,
} from "../../actions/domains";
import {Tooltip, Space, Button, Card, message, Popconfirm, Table, Switch} from "antd";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import {DEFAULT_PER_PAGE} from "../../config";
import {displayErrors} from "../../libs/utils";
import {ReloadOutlined} from "@ant-design/icons";
import {StatusIndicator} from "../shared/Status";
import AccessItem from "../permissions/AccessItem";
import {hasPermission} from "../permissions/PermissionUtils";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import DomainContentRuleModal from "./DomainContentRuleModal";
import {DateTimeFormat} from "../shared/DateTimeFormat";

class DomainContentRules extends React.Component {
    state = {
        loading: false,
        showModal: false,
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, showSizeChanger: true, total: 0 },
        rules: [],
        searchQuery: '',
        activeRule: '',
        ruleAction: 'ADD',
        updating: false,
        selectedRules: []
    };

    componentDidMount() {
        this.loadContentRules();
    }

    loadContentRules(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loading: true });

        this.props.loadContentRules(this.props.guid, page, per_page, this.state.searchQuery, (res) => {
            this.setState({
                loading: false,
                rules: res.data.data,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true } });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false });
            }
        });
    }

    toggleContentRuleStatus(guid, status) {
        let rules = this.state.rules.map((rule) => {
            if(rule.guid === guid) {
                let newStatus = status === 'ACTIVE' ? 'DISABLED' : 'ACTIVE';
                return {...rule, status: newStatus };
            }

            return rule;
        });

        this.setState({ loading: true, rules: rules });

        let data = {
            status: status === 'ACTIVE' ? 'DISABLED' : 'ACTIVE'
        };

        this.props.updateContentRule(this.props.guid, guid, data, () => {
            message.success('Rule successfully updated!');
            this.setState({ loading: false });

            this.loadContentRules();

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false });
            }
        });
    }

    deleteContentRule(guid) {
        this.setState({ loading: true });

        this.props.deleteContentRule(this.props.guid, guid, () => {
            message.success('Rule successfully deleted!')
            this.loadContentRules();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false });
            }
        });
    }

    render() {
        const columns = [];

        if(hasPermission(this.props.company.permissions, ['can_edit_domain_content_rules'])) {
            columns.push({ title: '', width: '20px', render: (item, row) => {
                    return <Tooltip title={row.status === 'ACTIVE' ? 'Disable rule' : 'Enable rule'}>
                        <Switch size='small' checked={row.status === 'ACTIVE'} onChange={() => this.toggleContentRuleStatus(row.guid, row.status)} />
                    </Tooltip>;
                }});
        }

        columns.push({ title: 'Name', width: '40%', dataIndex: 'name'})
        columns.push({ title: 'Created', dataIndex: 'date_created', align: 'left', render: (item) => <DateTimeFormat value={item} /> })
        columns.push({ title: 'Status', dataIndex: 'status', align: 'center', render: (item) => <StatusIndicator el='badge' status={item} /> })

        columns.push({ title: '', key: 'actions', 'align': 'right', render: (item, row) => {
                return <>
                    <AccessItem scopes={['can_edit_domain_content_rules']}>
                        <Button icon={<EditOutlined />} size='small' onClick={() => this.setState({ activeRule: item.guid, ruleAction: 'EDIT', showModal: true })}>Edit</Button>
                    </AccessItem>
                    <AccessItem scopes={['can_delete_domain_content_rules']}>
                        <Popconfirm
                            onConfirm={() => this.deleteContentRule(row.guid)}
                            placement='topRight'
                            title="Are you sure?"
                            okText="Delete"
                            cancelText="Cancel">
                            <Tooltip placement='left' title='Delete rule'>
                                <Button size='small' danger icon={<DeleteOutlined />} />
                            </Tooltip>
                        </Popconfirm>
                    </AccessItem>
                </>;
            }
        });

        return(
            <Fragment>
                <Card bordered={false} size='small' title='Content Rules' extra={<Space>
                    <AccessItem scopes={['can_add_domain_content_rules']}>
                        <Button type='primary' size='small' icon={<PlusOutlined />} onClick={() => this.setState({ showModal: true })}>Add Content Rule</Button>
                    </AccessItem>
                    <Tooltip title='Reload table'>
                        <Button size='small' icon={<ReloadOutlined />} onClick={() => this.loadContentRules()} />
                    </Tooltip>
                </Space>}>
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={this.state.rules}
                        pagination={this.state.pagination}
                        onChange={(pagination) => this.loadContentRules(pagination.current, pagination.pageSize)}
                        size='small'
                        bordered={false}
                        rowKey={(item) => item.guid} />
                </Card>

                <DomainContentRuleModal
                    showModal={this.state.showModal}
                    domainGuid={this.props.guid}
                    activeRule={this.state.activeRule}
                    ruleAction={this.state.ruleAction}
                    closeModal={() => this.setState({ showModal: false, activeRule: '', ruleAction: 'ADD' })}
                    reloadContentRules={() => this.loadContentRules()} />
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, { loadContentRules, updateContentRule, deleteContentRule })(DomainContentRules);